import type { ComponentProps, ReactNode } from "react"

import { Slot } from "@radix-ui/react-slot"

import { tv, type VariantProps } from "@/lib/utils/tv"

const iconButton = tv({
  base: "hit-target inline-flex size-11 shrink-0 cursor-pointer items-center justify-center rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
  variants: {
    press: { true: "press", false: "" },
    variant: {
      default: "border border-line-subtle bg-surface text-fg hover:bg-surface-newgray",
      brand: "border border-brand-subtle bg-brand-subtle text-fg-brand hover:bg-brand-muted",
      ghost: "bg-transparent text-fg hover:bg-surface-newgray",
      glass: "story-glass text-fg-inverted",
    },
  },
  defaultVariants: { variant: "default", press: true },
})

interface IconButtonProps extends ComponentProps<"button">, VariantProps<typeof iconButton> {
  icon?: ReactNode
  "aria-label": string
  asChild?: boolean
}

export const IconButton = ({ icon, variant, press, type = "button", className, asChild = false, children, ...rest }: IconButtonProps) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp className={iconButton({ variant, press, className })} {...(asChild ? {} : { type })} {...rest}>
      {asChild ? children : icon}
    </Comp>
  )
}
